import { ReactNode } from "react";
import { RichText } from "@/lib/nexus-app";
import { hasRichTextContent, isSafeHref } from "./utils/cookie-consent.utils";

function renderRichText(value: RichText, linkClassName: string): ReactNode {
  return value.map((segment, index) => {
    if (segment.type === "text") {
      return <span key={index}>{segment.value}</span>;
    }

    const href = segment.href.trim();
    if (!href || !isSafeHref(href)) {
      return <span key={index}>{segment.value}</span>;
    }

    return (
      <a
        key={index}
        href={href}
        target={segment.targetBlank ? "_blank" : undefined}
        rel={segment.targetBlank ? "noopener noreferrer" : undefined}
        className={linkClassName}
      >
        {segment.value}
      </a>
    );
  });
}

export function RichTextOrFallback({
  value,
  fallback,
  linkClassName,
}: {
  value: RichText | null | undefined;
  fallback: ReactNode;
  linkClassName: string;
}) {
  if (!hasRichTextContent(value)) return <>{fallback}</>;
  return <>{renderRichText(value!, linkClassName)}</>;
}
